import { Selling_Prices } from '@/types/cate-graphql-generated-types'
import { Currency, Money } from '@/types/graphql-generated-types'

import { formatPrice } from './format-currency'

export const formatListingPricePerSquareMeter = (
  sellingPrices: Selling_Prices,
  commercialArea: number,
  locale: Locale
): string | null => {
  if (sellingPrices && sellingPrices.cents && commercialArea) {
    const price: Money = {
      __typename: 'Money',
      cents: Math.round(sellingPrices.cents / commercialArea),
      currency: Currency.Eur,
    }
    return `${formatPrice(price, locale)}/m²`
  } else {
    return null
  }
}
